// extracted by mini-css-extract-plugin
module.exports = {"whatsAppCallIcon":"_3QMnz"};